import { useState, useEffect } from "react";

export default function ADPDetails({ details, setDetails, onApply }) {
  const [showDetails, setShowDetails] = useState(true);

  // İlk render'da pano adı boşsa varsayılan olarak "ADP" ata
  useEffect(() => {
    if (!details.panoAdi) {
      setDetails((prev) => ({ ...prev, panoAdi: "ADP" }));
    }
  }, [details.panoAdi, setDetails]);

  return (
    <div  >
      <button
        onClick={() => setShowDetails(!showDetails)}
        className="my-button"
        style={{
          width: '100%',
          textAlign: 'left',
        }}
      >
        {details.panoAdi} Detayları {showDetails ? '▴' : '▾'}
      </button>

      {showDetails && (
        <div className="panel-type-details-box">
          <table className="panel-type-details-table compact-table">
            <tbody>
              <tr>
                <td className="label-cell">Tür</td>
                <td>
                  <select
                    value={details.tur || "Tek Sayaç"}
                    onChange={(e) =>
                      setDetails({ ...details, tur: e.target.value })
                    }
                    style={{ width: "100%" }}
                  >
                    <option value="Tek Sayaç">Tek Sayaç</option>
                    <option value="Çok Sayaç">Çok Sayaç</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td className="label-cell">Pano Adı</td>
                <td>
                  <input
                    type="text"
                    value={details.panoAdi || ""}
                    onChange={(e) =>
                      setDetails({ ...details, panoAdi: e.target.value })
                    }
                    style={{ width: "100%" }}
                  />
                </td>
              </tr>

              <tr>
                <td className="label-cell">Faz Sayısı</td>
                <td>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <label>
                      <input
                        type="radio"
                        name="mainPanel_faz"   
                        checked={details.phaseCount === 1}
                        onChange={() => setDetails({ ...details, phaseCount: 1 })}
                      />
                      1 Faz
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="mainPanel_faz"
                        checked={details.phaseCount === 3}
                        onChange={() => setDetails({ ...details, phaseCount: 3 })}
                      />
                      3 Faz
                    </label>
                  </div>
                </td>
              </tr>

              <tr>
                <td colSpan={2}>
                  <button
                    onClick={onApply}
                    className="submit-button"
                    style={{ width: '100%' }}
                  >
                    ADP Ekle
                  </button>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
